import React from "react";
import Icon1 from "../../images/An.png";
import Icon2 from "../../images/Chris.png";
import Icon3 from "../../images/Trisian.png";
import Icon4 from "../../images/Abraham.jpg";

import {
  ServicesContainer,
  ServicesH1,
  ServicesWrapper,
  ServicesCard,
  ServicesIcon,
  ServicesH2,
  ServicesP,
} from "./ServicesElements";

const Services = () => {
  return (
    <ServicesContainer id="services">
      <ServicesH1>THE TEAM</ServicesH1>
      <ServicesWrapper>
        <ServicesCard>
          <ServicesIcon src={Icon1} />
          <ServicesH2>Anastasia</ServicesH2>
          <ServicesP>Designer</ServicesP>
        </ServicesCard>
        <ServicesCard>
          <ServicesIcon src={Icon2} />
          <ServicesH2>Chris</ServicesH2>
          <ServicesP>Director</ServicesP>
        </ServicesCard>
        <ServicesCard>
          <ServicesIcon src={Icon3} />
          <ServicesH2>Tristan</ServicesH2>
          <ServicesP>Marketing</ServicesP>
        </ServicesCard>
        <ServicesCard>
          <ServicesIcon src={Icon4} />
          <ServicesH2>Abraham</ServicesH2>
          <ServicesP>The Developer</ServicesP>
        </ServicesCard>
      </ServicesWrapper>
    </ServicesContainer>
  );
};

export default Services;
